import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from '@swimlane/ngx-datatable';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { HttpClient, HttpParams } from '@angular/common/http';

import { CaseViewApproveDialogComponent } from '../dg-approve/dg-approve.component';
import { SelectCaseDialogComponent } from '../selectCaseDialog/select-case-dialog.component';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { AppInitService } from 'src/app/digigov/services/app-init.service';

export interface DialogData {
  multiple: boolean;
  inputValue: string;
}

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

class Page {
  size: number;
}

@Component({
  selector: 'app-case-view-not-approve-dialog',
  templateUrl: './case-view-not-approve-dialog.component.html',
  styleUrls: ['./case-view-not-approve-dialog.component.scss'],
})
export class CaseViewNotApproveDialogComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  //rows = new Array<any>();
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  type = SelectionType.single;
  favoriteSeason = '1';
  clicked = false;
  seasons: string[] = ['Keep in Seen Folder', 'Send to Work Path'];
  columns = [{ prop: 'empName', name: 'Employee Name' }];
  selected = [];
  caseData: any;
  docId: any;
  rows = [];
  page = new Page();
  selectedEmp: any;
  postData = {
    recId: null,
    sendFlag: false,
    approveFlg: 1,
    //	toUnitId: null ,
    linkApproveFlag: true,
    appTypId: 1,
  };
  postData2 = {
    recId: null,
    sendFlag: true,
    approveFlg: 1,
    toUnitId: null,
    linkApproveFlag: true,
    appTypId: 1,
    orderNo: null,
  };
  orderNo;
  refIdList = '';
  showKeepInWorklist = false;
  showSendToWorkPath = false;
  showReturnToInitiator = false;
  subjectIdValue: number;
  constructor(
    public http: HttpClient,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CaseViewApproveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    public cdf: ChangeDetectorRef,
    public appInitService: AppInitService
  ) {
    this.page.size = 5;
  }

  showSendToWorkpath: boolean = true;

  ngOnInit(): void {
    this.appInitService?.getConfigurableFields()?.subscribe(() => {
      this.caseData = this.data?.selectedData[0];
      this.showKeepInWorklist = this.appInitService?.appConfig?.configurableFields?.showKeepInWorklist;
      this.showSendToWorkPath = this.appInitService?.appConfig?.configurableFields?.showSendToWorkPath;
      this.showReturnToInitiator = this.appInitService?.appConfig?.configurableFields?.showReturnToInitiator;
      this.subjectIdValue = this.appInitService?.appConfig?.configurableFields?.GENERIC_APPROVAL_SUB_ID;
      if (this.caseData?.subjectId === this.subjectIdValue) {
        this.showReturnToInitiator = true;
        this.showKeepInWorklist = false;
        this.showSendToWorkPath = false;
      }
      if (
        this.showKeepInWorklist === false &&
        this.showReturnToInitiator === true &&
        this.showSendToWorkPath === false
      ) {
        this.favoriteSeason = '3';
      } else if (
        this.showKeepInWorklist === false &&
        this.showReturnToInitiator === false &&
        this.showSendToWorkPath === true
      ) {
        this.favoriteSeason = '2';
      } else if (
        this.showKeepInWorklist === true &&
        this.showReturnToInitiator === false &&
        this.showSendToWorkPath === false
      ) {
        this.favoriteSeason = '1';
      }
      this.docId = this.caseData.docId;
      let listedItem = this.data?.selectedData;
      for (const s of listedItem) {
        this.refIdList += String(s.docId) + ',';
      }

      let params = new HttpParams();
      params = params.append('appTypeId', '1');
      params = params.append('refId', this.refIdList);
      params = params.append('actionId', '10000080');

      this.http
        .get('/workflow/hierarchy-details-revert', { params: params })
        .subscribe((res: any) => {
          this.rows.push(res.data[0].fileHierarchyVOArr[0]);
          this.orderNo = res?.data[0]?.fileHierarchyVOArr[0]?.unitLevel;
          this.onRadioClick(this.favoriteSeason);
        });
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  onSelect({ selected }): void {
    this.selectedEmp = selected;
  }

  onActivate(event: Event): void {}

  onRadioClick(favoriteSeason): void {
    if (favoriteSeason == 3) {
      this.clicked = true;
    } else {
      this.clicked = false;
    }
  }

  onSubmit(flag: boolean = false): any {
    if (this.clicked == true) {
      this.postData2.recId = Number(this.docId);
      this.postData2.orderNo = Number(this.orderNo);

      if (this.selectedEmp) {
        this.postData2.toUnitId = this.selectedEmp[0].unitId;
        if (!this.data?.isFromCustomAction) {
          this.http
            .post('/workflow/approve-reject', this.postData2)
            .subscribe((res) => {
              return this.closeOrReturnDialogReturn(true, flag);
            });
        } else {
          return this.closeOrReturnDialogReturn(this.postData2, flag);
        }
      } else {
        this.dialog.open(SelectCaseDialogComponent, {
          data: 'Please select Employee Name.',
        });
      }
    }
    if (this.clicked == false) {
      this.postData.recId = Number(this.docId);
      if (!this.data?.isFromCustomAction) {
        this.http
          .post('/workflow/approve-reject', this.postData)
          .subscribe((res) => {
            return this.closeOrReturnDialogReturn(true, flag);
          });
      } else {
        return this.closeOrReturnDialogReturn(this.postData, flag);
      }
    }
  }

  closeOrReturnDialogReturn(res, flag): any {
    if (!flag) {
      this.dialogRef.close(res);
    } else {
      return res;
    }
  }
}
